import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule, HttpHeaders } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { VerificationComponent } from './verification.component';
import { VerificationRoutingModule } from './verification-routing';
import { SharedModule } from '../../shared/shared.module';



@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    VerificationRoutingModule,
    SharedModule
  ],
  declarations: [
    VerificationComponent
  ],
  providers: []
})
export class VerificationModule { }
